import React, { useState } from "react";
import { DatePicker, TimePicker } from "antd";
import { StopWatchIcon } from "../../../common/icons";
import { useTranslation } from "react-i18next";
import "./scheduledInterviewSlots.css";

const ScheduledInterviewSlots = ({ slotData, heading, interviewLink }) => {
	const { t } = useTranslation();

	return (
		<div className="scheduledInterviewSlot_container">
			{heading && (
				<>
					<div className="scheduledInterviewSlot_container_header">
						<StopWatchIcon width={56} height={62.4} />
						<div className="scheduledInterviewSlot_container_header_title">
							{t(
								"internship_selectStudent_pageStepNotification_step4_primaryHeader"
							)}
						</div>
					</div>
				</>
			)}

			<div className="scheduledInterviewSlot_container_body">
				<table className="scheduledInterviewSlot_container_table">
					<tbody>
						{slotData.date1.dateString && (
							<tr>
								<td>
									Date1: <span>{slotData.date1.dateString}</span>
								</td>
								<td>
									{slotData.date1time1.startTimeString &&
										slotData.date1time1.endTimeString && (
											<>
												Time1:{" "}
												<span>{`${slotData.date1time1.startTimeString} ~ ${slotData.date1time1.endTimeString}`}</span>
											</>
										)}
								</td>
								<td>
									{slotData.date1time2.startTimeString &&
										slotData.date1time2.endTimeString && (
											<>
												Time2:{" "}
												<span>{`${slotData.date1time2.startTimeString} ~ ${slotData.date1time2.endTimeString}`}</span>
											</>
										)}
								</td>
								<td>
									{slotData.date1time3.startTimeString &&
										slotData.date1time3.endTimeString && (
											<>
												Time3:
												<span>{`${slotData.date1time3.startTimeString} ~ ${slotData.date1time3.endTimeString}`}</span>
											</>
										)}
								</td>
							</tr>
						)}
						{slotData.date2.dateString && (
							<tr>
								<td>
									Date2: <span>{slotData.date2.dateString}</span>
								</td>
								{slotData.date2time1.startTimeString &&
									slotData.date2time1.endTimeString && (
										<td>
											Time1:{" "}
											<span>{`${slotData.date2time1.startTimeString} ~ ${slotData.date2time1.endTimeString}`}</span>
										</td>
									)}
								{slotData.date2time2.startTimeString &&
									slotData.date2time2.endTimeString && (
										<td>
											Time2:{" "}
											<span>{`${slotData.date2time2.startTimeString} ~ ${slotData.date2time2.endTimeString}`}</span>
										</td>
									)}
								{slotData.date2time3.startTimeString &&
									slotData.date2time3.endTimeString && (
										<td>
											Time3:{" "}
											<span>{`${slotData.date2time3.startTimeString} ~ ${slotData.date2time3.endTimeString}`}</span>
										</td>
									)}
							</tr>
						)}
						{slotData.date3.dateString && (
							<tr>
								<td>
									Date3:<span>{slotData.date3.dateString}</span>
								</td>
								{slotData.date3time1.startTimeString &&
									slotData.date3time1.endTimeString && (
										<td>
											Time1:{" "}
											<span>{`${slotData.date3time1.startTimeString} ~ ${slotData.date3time1.endTimeString}`}</span>
										</td>
									)}
								{slotData.date3time2.startTimeString &&
									slotData.date3time2.endTimeString && (
										<td>
											Time2:{" "}
											<span>{`${slotData.date3time2.startTimeString} ~ ${slotData.date3time2.endTimeString}`}</span>
										</td>
									)}
								{slotData.date3time3.startTimeString &&
									slotData.date3time3.endTimeString && (
										<td>
											Time3:{" "}
											<span>{`${slotData.date3time3.startTimeString} ~ ${slotData.date3time3.endTimeString}`}</span>
										</td>
									)}
							</tr>
						)}
					</tbody>
				</table>
			</div>
			{heading && (
				<div className="scheduledInterviewSlot_container_footer">
					<span className="linkHeader">
						{t(
							"internship_selectStudent_pageStepNotification_step4_description"
						)}
					</span>
					<span className="link">{interviewLink}</span>
				</div>
			)}
		</div>
	);
};

export default ScheduledInterviewSlots;
